import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5l16 0","key":"svg-0"}],["path",{"d":"M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5","key":"svg-1"}]]

const IconBrandCss3 = createReactComponent('outline', 'brand-css3', 'BrandCss3', __iconNode);

export default IconBrandCss3;